function quickshop(currentid, handletitle) {
  if (!currentid) {
    return
  }
  if (!handletitle) {
    return
  }
  document.dispatchEvent(new CustomEvent('theme:loading:start'));
  $.getJSON(window.Shopify.routes.root + 'products/' + handletitle + '.js',
    function (data) {
      let variants = data["variants"]
      for (let i = 0; i < variants.length; i++) {
        if (variants[i]["id"] == currentid) {
          let formData = { 'items': [{ 'id': variants[i]["id"], 'quantity': 1 }] };
          fetch("".concat(window.routes.cartAddUrl, ".js"), {
            body: JSON.stringify(formData),
            credentials: 'same-origin',
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            }
          }).then(function (response) {
            if (response.status == 200){              
              document.dispatchEvent(new CustomEvent('product:added', {
                bubbles: true, detail: { variant: variants[i], quantity: 1 }
              }))
            }
          })
          document.dispatchEvent(new CustomEvent('theme:loading:end'));
          return
        }
      }
    }
  )
  document.dispatchEvent(new CustomEvent('theme:loading:end'));
}
